const TABS = [
  ["current", "01", "Current setup", "Is it working? Who is in it?"],
  ["long", "02", "Long-term outlook", "What it implies & why"],
  ["short", "03", "Short-term outlook", "Progress & regime nowcast"],
  ["earnings", "04", "Earnings", "Next report & watchlist"],
];
export const TAB_IDS = TABS.map((t) => t[0]);

export const SrTabs = ({ tab, onTab }) => {
  const n = TABS.length;
  const key = (e, i) => {
    const j = { ArrowRight: (i + 1) % n, ArrowLeft: (i + n - 1) % n, Home: 0, End: n - 1 }[e.key];
    if (j === undefined) return;
    e.preventDefault();
    onTab(TAB_IDS[j]);
    document.getElementById(`tab-${TAB_IDS[j]}`)?.focus();
  };
  return (
    <div className="screenTabs" role="tablist" aria-label="Stock research horizon">
      {TABS.map(([id, num, b, s], i) => (
        <button key={id} id={`tab-${id}`} role="tab" aria-selected={tab === id} aria-controls={`screen-${id}`}
          tabIndex={tab === id ? 0 : -1} onClick={() => onTab(id)} onKeyDown={(e) => key(e, i)} data-testid={`sr-tab-${id}`}>
          <span>{num}</span><b>{b}</b><small>{s}</small>
        </button>
      ))}
    </div>
  );
};
